import { render, staticRenderFns } from "./varejo.vue?vue&type=template&id=6bfdceea&scoped=true&"
import script from "./varejo.vue?vue&type=script&lang=js&"
export * from "./varejo.vue?vue&type=script&lang=js&"
import style0 from "./varejo.vue?vue&type=style&index=0&id=6bfdceea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdceea",
  null
  
)

export default component.exports